export const isNullOrUndefined = (value) => value == null;
